<template>
  <div>
    <v-header></v-header>

    <div style="padding-top: 60px;">
      <div class="banner">
        <img src="../../static/img/banner-top-1.png" alt="" />
        <h2 class="item-title"><span class="ch">凡高教育</span> <span class="eg">推动教育信息化，共享美好未来</span></h2>
      </div>
      

      <div   class="service">
        <h2   class="item-title"><span   class="eg">公司简介</span> <span   class="ch">Company Profile</span></h2>
        <p class="servicepone" >
            北京元新科技有限公司专注于智慧校园管理软件的开发，推广及运营，推出的核心产品有无现金缴费系统、校园一卡通系统、假期作业系统、家校互联、成绩分析系统等业务，为教育用户提供丰富优质的互联网教育服务。
        </p >
        <p class="servicep">公司位于北京，拥有强大的技术研发和产品创新能力，并与诸多教育同行建立广泛合作，实现技术与教育的紧密融合。</p>
       
      </div>

       <div   class="chuangservice">
        <h2   class="item-title"><span   class="eg">创始人介绍</span> <span   class="ch">Founder Introduction</span></h2>
        <div class="chuangcontent">
            <p class="touxiang"></p>
            <p class="name">王新</p>
            <div class="jieshao">
                硕士研究生，北京元新科技有限公司创始人，从事互联网行业工作十余年，擅长产品分析与市场策略。
            </div>
            <div class="jieshao">
                                毕业于：华北电力大学计算机应用专业
            </div>
            <div class="jieshao">
                工作经历：港湾网络有限公司任研发主管一职
              <p  style="margin-left:65px">中兴通讯海外市场部任客户经理岗位</p>
              <p style="margin-left:65px">乐宠科技有限公司移动事业部担任VP</p>
                            
            </div>
        </div>
       
      </div>


       <div   class="joinservice">
        <h2   class="item-title"><span   class="eg">加入我们</span> <span   class="ch">Join US</span></h2>
        <p class="joinp" style="margin-top:20px"> 详细简历请以姓名+应聘职位名称发送至：<span style="color:#2AB1F3">hr@fangaoyun.com</span> </p>
        <p  class="joinp">我们的HR将会第一时间与您联系，真诚欢迎优秀人才加入我们 </p>
        <div class="joincontent" style="margin-top:50px">
          <p class="onep">php开发工程师</p>
          <p class="twop">技术部门/北京</p>
          <p class="threep"></p>
          
          <p class="fourp">任职要求：</p>
          <p class="fivep">1、具备至少5年以上的php项目开发经验，熟悉CI等主流PHP开发框架；</p>
          <p class="fivep">2、熟练掌握HTTP协议,熟练使用关系数据库MySQL并掌握常用mysql优化手段；</p>
          <p class="fivep"> 3、熟悉Redis，memcache等nosql数据存储，使用过MQ消息队列； </p>
          <p class="fivep">4、熟练使用shell,了解apache/nginx的安装；</p>
          <p class="fivep">5、有良好的沟通能力和理解能力,较强的学习能力。</p>
        </div>
        <div class="joincontent">
             <p class="onep" style="color:#5FCAAC">web前端</p>
              <p class="twop">技术部门/北京</p>
              <p class="threep"></p>
              
              <p class="fourp">任职要求：</p>
              <p class="fivep">1、计算机相关专业，就职互联网公司，3年以上团队管理经验，良好的沟通能力；</p>
              <p class="fivep">2、精通html/css/JavaScript等前端相关技术 ，熟悉前端相关框架以及技术栈，有前端框架设计能力;</p>
              <p class="fivep">3、熟练掌握git，熟悉W3C标准，对表现与数据分离、Web语义化等有深刻理解；</p>
              <p class="fivep">4、熟悉VUE、React、Angular中至少一种前端框架；</p>
              <p class="fivep">5、熟悉weex、react native中至少一种框架。</p>
        </div>

        <div class="joincontent">
             <p class="onep" style="color:#F4B254">产品经理</p>
              <p class="twop">技术部门/北京</p>
              <p class="threep"></p>
              
              <p class="fourp">任职要求：</p>
              <p class="fivep">1、产品规划、需求管理、产品设计；</p>
              <p class="fivep">2、与客户沟通需求，可引导客户提出自己的见解；</p>
              <p class="fivep">3、熟练掌握axure，输出原型、流程图等交付物；</p>
              <p class="fivep"> 4、承担客户与研发团队之间的桥梁，把理解的需求无缝传递至研发团队；</p>
              <p class="fivep">5、竞品分析能力，收集竞争对手资料，了解竞争对手产品。 </p>
        </div>

        <div class="joincontent">
             <p class="onep" style="color:#677BD8">运营经理</p>
              <p class="twop">技术部门/北京</p>
              <p class="threep"></p>
              
              <p class="fourp">任职要求：</p>
              <p class="fivep"> 1、依据公司战略定位，分析和调研行业市场，制定智慧校园业务发展策略，建立和完善业务运营体系； </p>
              <p class="fivep"> 2、负责合作学校的运营工作，包括市场调研分析、项目定位、产品方案、团队组建、营销推广、现场管控、关系维护等； </p>
              <p class="fivep"> 3、负责制定合作学校的管理标准和相关增值服务的开发及引入；</p>
              <p class="fivep">4、负责项目的策划、定位，全面负责产品体系的搭建，并组织实施； </p>
              <p class="fivep"> 5、具备较强的分析问题能力和解决问题的能力，有项目管理经验、良好的人际沟通能力、业务运营能力。 </p>
        </div>
      </div>
    
    </div>


    <v-footer></v-footer>
  </div>
</template>

<script>
  import Vue from 'vue'
  import header from './header.vue'
  import footer from './footer.vue'
  export default {
    name: 'HelloWorld',
    data () {
      return {
       
      }
    },
    components :{
      'v-header':header,
      'v-footer':footer,
    },
    methods: {
   
    }

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .header {
    width: 100%;
    -ms-flex-negative: 0;
    flex-shrink: 0
  }

  .main {
    -ms-flex: 1;
    flex: 1;
    overflow: hidden;
    overflow-y: auto
  }

  .footer {
    width: 100%;
    -ms-flex-negative: 0;
    flex-shrink: 0
  }

  .text-ellipsis {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap
  }

  .moreline-ellipsis {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2
  }

  .clearfix:after {
    content: "";
    height: 0;
    width: 0;
    display: block;
    clear: both
  }
.servicep{
  /* text-align: center; */
  margin: 0 auto;
  width:696px;
  font-size:24px;
  font-family:PingFang SC;
  font-weight:400;
  color:rgba(0,0,0,1);
  line-height:36px;
  margin-top: 40px;
}
.servicepone{
  /* text-align: center; */
  margin: 0 auto;
  width:696px;
  font-size:24px;
  font-family:PingFang SC;
  font-weight:400;
  color:rgba(0,0,0,1);
  line-height:36px;
  margin-top: 80px;
}
  .item-title {
    text-align: center;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: center;
    justify-content: center;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-direction: column;
    flex-direction: column;
    /* margin-top: 100px; */
  }
  .item-title .eg {
    margin-bottom: 20px;
    font-size:36px;
font-family:PingFang SC;
font-weight:bold;
color:rgba(0,0,0,1);
  }
  .item-title .ch {
    /* margin-bottom: 80px; */
    width:508px;
    height:60px;
    font-size:24px;
    font-family:PingFang SC;
    font-weight:400;
    color:rgba(0,0,0,1);
/* line-height:36px; */
  }

  .product-introduction {
    margin-top: 40px;
    padding: 0 5%;
    letter-spacing: 1px;
    line-height: 24px
  }

  .button {
    background: transparent;
    border: 1px solid #ff9a00;
    color: #ff9a00
  }

  .banner {
    width: 100%;
    color: #fff;
    position: relative
  }

  .banner img {
    width: 100%
  }


  .banner .item-title {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: center;
    justify-content: center;
    -ms-flex-direction: column;
    flex-direction: column
  }

  .banner .item-title .ch {
   font-size:40px;
font-family:PingFang SC;
font-weight:400;
color:rgba(255,255,255,1);
  }

  .banner .item-title .eg {
    font-size:22px;
font-family:PingFang SC;
font-weight:400;
color:rgba(255,255,255,1);
/* line-height:34px; */
margin-top: 20px;
  }
.service  {
    padding: 100px 0;
    
  }

  .service .item-pro  {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-direction: column;
    flex-direction: column
  }
  /* 创始人介绍 */
.chuangservice  {
    padding: 100px 0;
    background-image: url('~@/../static/img/chuang-banner.png');
    background-size: 100% 100%;
  }
 /* 创始人介绍 */
  .chuangservice .item-pro  {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-direction: column;
    flex-direction: column
  }
.chuangcontent{
  
  width: 100%;
  margin: 0 auto;
  /* text-align: center; */
  margin-top: 80px;
}
.chuangcontent .touxiang{
width:250px;
height:250px;
background:rgba(42,177,243,1);

 margin: 0 auto;
 /* margin-top: 80px; */
}
.chuangcontent .name{
  font-size:30px;
  text-align: center;
font-family:PingFang SC;
font-weight:bold;
color:rgba(42,177,243,1);
line-height:45px;
margin: 40px auto;
padding-bottom: 30px;
width:560px;
border-bottom:1px solid rgba(42,177,243,1);
}
.chuangcontent .jieshao{
  margin: 0 auto;
width:559px;
/* height:60px; */
font-size:24px;
font-family:PingFang SC;
font-weight:400;
color:rgba(0,0,0,1);
line-height:38px;
margin-bottom: 35px;
}
/* 加入我们 */

.joinservice  {
    padding: 100px 0;
   
  }

  .joinservice .item-pro  {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-direction: column;
    flex-direction: column
  }
  .joinservice .joinp{
    text-align: center;
    /* width:685px; */
    font-size:24px;
    font-family:PingFang SC;
    font-weight:400;
    color:rgba(0,0,0,1);
    line-height:36px;
  }
  .joinservice .joincontent{
    width:692px;
    /* height:590px; */
    background:rgba(255,255,255,1);
    box-shadow: 0 1px 6px rgba(0, 0, 0, .2);
    /* margin-bottom: 60px; */
    margin: 60px auto;
    padding: 35px 0;
  }
  .joinservice .joincontent .onep{
    width:642px;
    font-size:36px;
    font-family:PingFang SC;
    font-weight:bold;
    color:rgba(236,114,101,1);
    /* line-height:21px; */
    margin: 0px auto;
  }
  .joinservice .joincontent .twop{
    width:642px;
font-size:24px;
font-family:PingFang SC;
font-weight:400;
color:rgba(0,0,0,1);
margin: 30px auto;
/* line-height:21px; */
  }
  .joinservice .joincontent .threep{
width:642px;
height:1px;
background:rgba(226,226,226,1);
margin: 30px auto;
  }
  .joinservice .joincontent .fourp{
    width:642px;
font-size:24px;
font-family:PingFang SC;
font-weight:bold;
color:rgba(0,0,0,1);
/* line-height:21px; */
margin:20px auto;
  }
  .joinservice .joincontent .fivep{
    width:642px;
    font-size:24px;
    font-family:PingFang SC;
    font-weight:400;
    color:rgba(0,0,0,1);
    line-height:36px;
    margin: 10px auto;
  }
  .service dl  {
    display: -ms-flexbox;
    display: flex;
    margin-top: 30px
  }

  .service dl dt  {
    -ms-flex-negative: 0;
    flex-shrink: 0;
    margin: 0 15px 0 20px
  }

  .service dl dt img  {
    height: 120px;
    width: 120px
  }
   .service dl dd  {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-direction: column;
    flex-direction: column;
    padding-right: 30px;
    -ms-flex: 1;
    flex: 1
  }

</style>



// WEBPACK FOOTER //
// src/components/businesscooperation.vue